<template>
    <div class="view">
        <h2>Besoins prévisionnels en recrutements</h2>
        <b-form @submit="onSubmit" v-if="show" @keypress.enter.prevent>
            <b-col cols="10" >
                <b-row align-h="between">
                    <b-col cols="4" >
                        <b-form-group id="input-group-marches" label-for="input-marches" v-if="isAdmin">
                            <template v-slot:label>
                                <label-custom
                                        label="Marché"
                                        :tooltip=libelles.infoBulleNumMarche
                                        :required="true">
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                    id="input-marches"
                                    :items="marcheIdsItems"
                                    v-model="marcheAdmin"
                                    @search="onMarcheSearch"
                                    :required="true"
                                    :disabled="mode === 'UPDATE' || mode === 'READ'"
                                    :placeholder=libelles.selectionnerMarche
                            >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <div class="user-info">
                            <p style="margin-bottom: 10px; text-align: center;">
                                <strong>Créateur de la saisie</strong>
                            </p>
                            <template v-if="user.nom.trim() || user.prenom.trim() || user.email.trim()">
                                <p><strong>Nom :</strong> {{ user.nom }}</p>
                                <p><strong>Prénom :</strong> {{ user.prenom }}</p>
                                <p><strong>Email :</strong> {{ user.email }}</p>
                            </template>
                            <template v-else>
                                <p class="no-data">La donnée n’est pas disponible</p>
                            </template>
                        </div>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group
                                id="input-group-trimestres"
                                label-for="input-trimestres">
                            <template v-slot:label>
                                <label-custom
                                        label="Trimestre de la saisie"
                                        tooltip="Trimestre au cours duquel la saisie est réalisée, à ne pas confondre avec les trimestres pour lesquels la saisie est réalisée, et qui apparaissent plus bas"
                                        :required="true">
                                </label-custom>
                            </template>
                            <b-form-select
                                    id="input-trimestres"
                                    v-model="trimestreAdmin"
                                    :options="trimestresAdmin"
                                    :disabled="mode === 'UPDATE' || mode === 'READ'"
                                    @change="callInit"
                                    :state="getFieldState(trimestreAdmin != null)">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Sélectionner un trimestre
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col cols="8" v-if="marcheId && trimestreAdmin && mode === 'CREATE'">
                        <label-custom :label=libelles.libelleRienDeclarer></label-custom>
                        <b-button type="button" variant="primary" v-b-modal="'modal-dispense'">
                            {{libelles.buttonRienDeclarer}}
                        </b-button>
                        <b-modal
                                :id="'modal-dispense'"
                                :title=libelles.demandeConfirmation
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="saveDispense()">
                            <p>{{libelles.confirmationDispenseUtilisateur}}</p>
                        </b-modal>
                    </b-col>
                </b-row>
                <div v-if="marcheId && trimestreAdmin">
                    <b-card header="Filtres de recherche" class="mb-3 mt-3">
                        <b-row>
                            <b-col>
                                <b-form-group
                                        label="Filtrer par libellé de poste"
                                        id="input-group-filterLibellePoste"
                                        label-for="input-filterLibellePoste">
                                    <b-form-input
                                            id="input-group-filterLibellePoste"
                                            v-model="filterLibellePoste"
                                            type="text"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                        label="Filtrer par statut de validation"
                                        id="input-group-filterStatutPoste"
                                        label-for="input-filterStatutPoste">
                                    <b-form-select v-model="filterStatutPoste">
                                        <b-form-select-option :value="null">
                                            Tous
                                        </b-form-select-option>
                                        <b-form-select-option :value="'valid'">
                                            Validés et incomplets
                                        </b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>

                    <b-tabs content-class="mt-3" fill v-model="currentTrimestre" lazy>
                        <b-tab
                                :title="formatTrimestre(trimestre.libelle)"
                                v-for="(trimestre, trimestreIndex) in synthese.trimestresSuivants"
                                :key="trimestreIndex">
                            <template #title>
                                <div v-b-tooltip.hover
                                     :title="'Les trimestres saisis ci-dessous correspondent aux trimestres T+1; T+2; T+3, T+4'">
                                    {{formatTrimestre(trimestre.libelle)}}
                                </div>
                            </template>
                            <b-row align-h="end" class="mb-3">
                                <b-col cols="3"><span class="typo-orange">* </span>{{ libelles.champsObligatoires }}</b-col>
                            </b-row>
                            <div class="accordion" role="tablist">
                                <div v-for="(poste, posteIndex) in currentPostes" :key="posteIndex">
                                    <div v-if="posteIndex === 0 || poste.codeRome.type !== currentPostes[posteIndex - 1].codeRome.type">
                                        <b-card class="text-center" v-if="poste.codeRome.type != null">
                                            {{ typologiePosteEnum[poste.codeRome.type] }}
                                        </b-card>
                                        <b-card class="text-center" v-if="poste.codeRome.type == null">
                                            Type non renseigné
                                        </b-card>
                                    </div>
                                    <b-card no-body class="mb-1">
                                        <b-card-header
                                                header-tag="header"
                                                class="p-1 mb-0"
                                                role="tab">
                                            <b-row>
                                                <b-col cols="11">
                                                    <b-button
                                                            block
                                                            v-b-toggle="'poste_' + trimestreIndex + '_' + posteIndex"
                                                            :variant="getStatus(poste)"
                                                            @click="initTrimestresToDuplicate(poste)">
                                                        {{ poste.codeRome.libelle }} ({{ poste.codeRome.code }})
                                                    </b-button>
                                                </b-col>
                                                <b-col cols="1">
                                                    <b-button
                                                            v-b-modal="'modal-delete' + trimestreIndex + '_' + posteIndex"
                                                            variant="danger"
                                                            v-b-tooltip.hover
                                                            :title="'Supprimer le poste de la liste'"
                                                            :disabled="mode === 'READ'">

                                                        <Icon icon="trash" size="1x"></Icon>
                                                    </b-button>
                                                    <b-modal
                                                            :id="'modal-delete' + trimestreIndex + '_' + posteIndex"
                                                            :title="poste.codeRome.libelle"
                                                            ok-title="Confirmer"
                                                            cancel-title="Annuler"
                                                            @ok="deletePoste(posteIndex)">
                                                        <p>Souhaitez-vous supprimer ce poste de la liste du référentiel
                                                            ?</p>
                                                        <p>Si vous poursuivez, le poste n’apparaîtra plus pour ce
                                                            trimestre,
                                                            mais pourra être de nouveau ajouté manuellement en cliquant
                                                            sur ‘Ajouter un nouveau poste’.
                                                        </p>
                                                    </b-modal>
                                                </b-col>
                                            </b-row>
                                        </b-card-header>
                                        <b-collapse
                                                :id="'poste_' + trimestreIndex + '_' + posteIndex"
                                                :accordion="'my-accordion_' + trimestreIndex"
                                                role="tabpanel">
                                            <b-card-body>
                                                <b-row>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-typePoste_' + trimestreIndex + '_' + posteIndex"
                                                                :label-for="'input-typePoste_' + trimestreIndex + '_' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Typologie de poste"
                                                                        :required="true">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-select
                                                                    :id="'input-typePoste_' + trimestreIndex + '_' + posteIndex"
                                                                    v-model="poste.codeRome.type"
                                                                    :options="typologies"
                                                                    @change="poste.isTouched = true"
                                                                    :disabled="true"
                                                                    :state="getFieldState(poste.codeRome.type != null, poste)">
                                                            </b-form-select>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-ouvertureInsertion_' + trimestreIndex + '_' + posteIndex"
                                                                :label-for="'input-ouvertureInsertion_' + trimestreIndex + '_' +posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Ouverture du poste à l'insertion"
                                                                        tooltip="Sélectionner oui ou non suivant que le poste puisse répondre à la clause d’insertion"
                                                                        :required="true">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-radio-group
                                                                    :id="'input-ouvertureInsertion_' + trimestreIndex + '_' +posteIndex"
                                                                    v-model="poste.ouvertureInsertion"
                                                                    :buttons="true"
                                                                    button-variant="outline-primary"
                                                                    @change="poste.isTouched = true;onOuvertureInsertionChange(poste);"
                                                                    :state="getFieldState(poste.ouvertureInsertion != null, poste)"
                                                                    :disabled="mode === 'READ'">
                                                                <b-form-radio :value="true">Oui</b-form-radio>
                                                                <b-form-radio :value="false">Non</b-form-radio>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col>
                                                        <b-form-group
                                                                :id="'input-group-nbRecrutement_' + trimestreIndex + '_' +posteIndex"
                                                                :label-for="'input-nbRecrutement_' + trimestreIndex + '_' + posteIndex">
                                                            <template v-slot:label>
                                                                <label-custom
                                                                        label="Nombre d'effectifs"
                                                                        tooltip="Indiquer le nombre d’effectifs recrutés en équivalent temps plein"
                                                                        :required="true">
                                                                </label-custom>
                                                            </template>
                                                            <b-form-input
                                                                    :id="'input-nbRecrutement_' + trimestreIndex + '_' + posteIndex"
                                                                    v-model="poste.nbRecrutement"
                                                                    type="number"
                                                                    min="0"
                                                                    step="any"
                                                                    v-on:input="poste.isTouched = true"
                                                                    :state="getFieldState(isFilledInput(poste.nbRecrutement), poste)"
                                                                    :disabled="mode === 'READ'"></b-form-input>
                                                            <div class="typo-warning"
                                                                 v-if="!areTypesContratValid(poste)">
                                                                Le nombre d'effectifs total renseignés et les
                                                                effectifs associés à chaque type de contrat ne
                                                                correspondent pas
                                                            </div>
                                                            <div class="typo-warning"
                                                                 v-if="!areTypesFormationValid(poste)">
                                                                Le total des effectifs en formation saisi est
                                                                supérieur au total des effectifs à recruter sur
                                                                ce poste. Merci de modifier votre saisie afin de
                                                                la rendre valide
                                                            </div>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-card no-body class="mb-2">
                                                    <b-card-header>
                                                        <div class="typo-required-field">
                                                            Type de contrat envisagé
                                                        </div>
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <type-contrat-gpec
                                                                v-model="poste.typesContrat"
                                                                :typesContratEnum="typesContratEnum"
                                                                :formSubmitted="formSubmitted"
                                                                :posteTouched="poste.isTouched"
                                                                v-on:input="poste.isTouched = true"
                                                                :disabled="mode === 'READ'"></type-contrat-gpec>
                                                    </b-card-body>
                                                </b-card>
                                                <b-card no-body>
                                                    <b-card-header
                                                            header-tag="header"
                                                            v-b-tooltip.hover
                                                            :title="'Indiquer la mise en place d’une éventuelle formation dispensée en accompagnement du poste'">
                                                        Formation principale délivrée
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <formation-gpec
                                                                v-model="poste.formation"
                                                                :trimestreIndex="trimestreIndex"
                                                                :posteIndex="posteIndex"
                                                                :typesFormation="typesFormation"
                                                                :formSubmitted="formSubmitted"
                                                                :posteTouched="poste.isTouched"
                                                                v-on:input="poste.isTouched = true"
                                                                :nbInsertionDisabled="!poste.ouvertureInsertion"
                                                                :disabled="mode === 'READ'"></formation-gpec>
                                                    </b-card-body>
                                                </b-card>
                                                <b-card
                                                        no-body
                                                        class="mt-2"
                                                >
                                                    <b-card-header
                                                            header-tag="header"
                                                            v-b-tooltip.hover
                                                            :title="'Informations supplémentaires facultatives concernant le profil souhaité sur le poste pour orienter la recherche de candidat'">
                                                        Profil de poste
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col>
                                                                <b-form-group
                                                                        :id="'input-group-missions-principales_' + trimestreIndex + '_' + posteIndex"
                                                                        :label-for="'input-missions-principales_' + trimestreIndex + '_' + posteIndex"
                                                                >
                                                                    <label-custom
                                                                            label="Missions principales"
                                                                            tooltip="Descriptif de tâches et missions"
                                                                    >
                                                                    </label-custom>
                                                                    <b-form-textarea
                                                                            v-on:keyup.enter='addLineBreak($event,poste,"missionsPrincipales",true)'
                                                                            :id="'input-missions-principales_'+ trimestreIndex + '_' + posteIndex"
                                                                            :value="poste.missionsPrincipales"
                                                                            rows="3"
                                                                            max-rows="4"
                                                                            :disabled="mode === 'READ'"
                                                                            v-on:change='addLineBreak($event,poste,"missionsPrincipales")'
                                                                    >
                                                                    </b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col>
                                                                <b-form-group
                                                                        :id="'input-group-competences-requises_'+ trimestreIndex + '_' + posteIndex"
                                                                        :label-for="'input-compétences-requises_' + + trimestreIndex + '_' + posteIndex"
                                                                >
                                                                    <label-custom
                                                                            label="Compétences requises"
                                                                            tooltip="Descriptif des savoir-faire et savoir-être requis"
                                                                    >
                                                                    </label-custom>
                                                                    <b-form-textarea
                                                                            v-on:keyup.enter='addLineBreak($event,poste,"competensesRequises",true)'
                                                                            :id="'input-competences-requises_' + trimestreIndex + '_' + posteIndex"
                                                                            :value="poste.competensesRequises"
                                                                            rows="3"
                                                                            max-rows="4"
                                                                            :disabled="mode === 'READ'"
                                                                            @change='addLineBreak($event,poste,"competensesRequises")'>
                                                                    </b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="6">
                                                                <b-form-group
                                                                        :id="'input-group-qualifications-diplomes_' + trimestreIndex + '_' + posteIndex"
                                                                        :label-for="'input-qualifications-diplomes_' + trimestreIndex + '_' + posteIndex"
                                                                >
                                                                    <label-custom
                                                                            label="Qualifications ou diplômes attendus"
                                                                            tooltip="Descriptif du niveau d'étude et des diplômes attendus"
                                                                    >
                                                                    </label-custom>
                                                                    <b-form-textarea
                                                                            v-on:keyup.enter='addLineBreak($event,poste,"qualificationsDiplomes",true)'
                                                                            :id="'input-missions-qualifications-diplomes_' + trimestreIndex + '_' +posteIndex"
                                                                            :value="poste.qualificationsDiplomes"
                                                                            rows="3"
                                                                            max-rows="4"
                                                                            :disabled="mode === 'READ'"
                                                                            @change='addLineBreak($event,poste,"qualificationsDiplomes")'>
                                                                    </b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-card>

                                                <b-card
                                                        no-body
                                                        class="mt-2"
                                                >
                                                    <b-card-header
                                                            header-tag="header"
                                                            v-b-tooltip.hover
                                                            :title=gpecPrevisionnel.infoBulleEntreprisesConcernees>
                                                        {{gpecPrevisionnel.libelleEntreprisesConcernees}}
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col>
                                                                <b-form-group
                                                                        :id="'input-group-entreprisesConcernees_' + trimestreIndex + '_' + posteIndex"
                                                                        :label-for="'input-entreprisesConcernees_' + trimestreIndex + '_' + posteIndex"
                                                                >
                                                                    <b-form-textarea
                                                                            v-on:keyup.enter='addLineBreak($event,poste,"entreprisesConcernees",true)'
                                                                            :id="'input-entreprisesConcernees_'+ trimestreIndex + '_' + posteIndex"
                                                                            :value="poste.entreprisesConcernees"
                                                                            rows="3"
                                                                            max-rows="4"
                                                                            :disabled="mode === 'READ'"
                                                                            v-on:change='addLineBreak($event,poste,"entreprisesConcernees")'
                                                                    >
                                                                    </b-form-textarea>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-card>

                                                <b-card
                                                        no-body
                                                        class="mt-2"
                                                        v-if="isValid(poste) && mode !== 'READ'">
                                                    <b-card-header
                                                            header-tag="header"
                                                            v-b-tooltip.hover
                                                            :title="'Dupliquer le besoin sur un ou plusieurs trimestres à venir'">
                                                        Dupliquer le besoin sur un ou plusieurs trimestres à venir
                                                    </b-card-header>
                                                    <b-card-body>
                                                        <b-row>
                                                            <b-col class="text-center">
                                                                <MultiselectCustom
                                                                        :options="trimestres"
                                                                        v-model="poste.trimestresToDuplicate"
                                                                        :defaultLabel="'Sélectionner un trimestre'"
                                                                        id="input-trimestres">
                                                                </MultiselectCustom>
                                                            </b-col>
                                                            <b-col class="text-center">
                                                                <b-button
                                                                        type="button"
                                                                        variant="primary"
                                                                        @click="duplicatePoste(poste, posteIndex)"
                                                                        :disabled="poste.trimestresToDuplicate.length === 0">
                                                                    Dupliquer le poste
                                                                </b-button>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card-body>
                                                </b-card>
                                                <b-row class="mt-3" v-if="mode === 'CREATE'">
                                                    <b-col class="text-center">
                                                        <b-button
                                                                type="button"
                                                                variant="primary"
                                                                @click="saveDraft(false)"
                                                                :disabled="!isValid(poste)">
                                                            Enregistrer le poste
                                                        </b-button>
                                                    </b-col>
                                                </b-row>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </div>
                            <div v-if="currentPostes && currentPostes.length === 0">
                                Aucun poste ne correspond à vos critères de recherche
                            </div>
                        </b-tab>
                    </b-tabs>
                    <b-row class="mt-3">
                        <b-col class="text-center">
                            <b-button
                                    type="button"
                                    variant="primary"
                                    @click="showModalAddPoste"
                                    v-if="mode === 'CREATE' || mode === 'UPDATE'">
                                Ajouter un nouveau poste
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-modal
                            id="modal-add-poste"
                            title="Ajouter un nouveau poste"
                            ok-title="Confirmer"
                            cancel-title="Annuler"
                            hide-footer
                            @hidden="addPoste">
                        <CreerCodeRome :codeRome="newCodeRome"></CreerCodeRome>
                    </b-modal>
                </div>

                <b-row v-if="mode !== 'CREATE'">
                    <b-col>
                        <b-form-group
                                id="input-group-commentaire"
                                label-for="input-commentaire"
                        >
                            <label-custom
                                    label="Commentaire"
                                    tooltip="Espace à compléter si vous souhaitez préciser le motif de la modification du formulaire"
                                    :required="synthese.jourSoumissionPassed"
                            >
                            </label-custom>
                            <b-form-textarea v-on:keyup.enter='addLineBreak($event,synthese,"commentaire",true)'
                                             id="input-commentaire"
                                             :value="synthese.commentaire"
                                             rows="3"
                                             max-rows="5"
                                             :state="getCommentaireState()"
                                             @change='addLineBreak($event,synthese,"commentaire")'
                                             :disabled="mode === 'READ'"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6" v-if="synthese.statut === 'REFUSE'">
                        <b-form-group
                            id="input-group-commentaire-statut"
                            :label=libelles.commentaireStatut
                            label-for="input-commentaire-statut"
                        >
                            <b-form-textarea
                                id="input-commentaire"
                                :value="synthese.commentaireStatut"
                                rows="3"
                                max-rows="5"
                                disabled
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>


                <div class="pt-2" v-if="mode !== 'READ'">
                    <b-button
                            type="submit"
                            variant="primary"
                            @click="formSubmitted = true">Soumettre le formulaire
                    </b-button>
                </div>

                <div class="pt-2" v-if="mode === 'READ' && isAdminGpec">
                    <b-button
                            v-if="synthese.statut === 'ATTENTE_MODIFICATION' || synthese.statut === 'ATTENTE_SUPPRESSION'"
                            type="button"
                            variant="primary"
                            @click="validerSynthese(synthese)">
                        <span v-if="synthese.statut === 'ATTENTE_MODIFICATION'">Confirmer la modification</span>
                        <span v-if="synthese.statut === 'ATTENTE_SUPPRESSION'">Confirmer la suppression</span>
                    </b-button>
                </div>
            </b-col>
        </b-form>
        <br/>
    </div>
</template>

<script>
  import SessionStore from "@/stores/SessionStore";
  import AlertStore from "@/stores/AlertStore";
  import hasPermission from "../../../filters/hasPermission";
  import MarcheStore from "../../../stores/MarcheStore";
  import TypeFormationStore from "../../../stores/TypeFormationStore";
  import GpecSynthesePrevisionnelStore from "../../../stores/GpecSynthesePrevisionnelStore";
  import LabelCustom from "../../../components/LabelCustom";
  import CreerCodeRome from "../../code-rome/CreerCodeRome";
  import TypeContratGpec from "../../../components/gpec/TypeContratGpec";
  import FormationGpec from "../../../components/gpec/FormationGpec";
  import GpecSynthesePrevisionnelDto from "../../../dtos/GpecSynthesePrevisionnelDto";
  import {TypeContratEnum, TypologiePosteEnum} from "../../../constants/enums";
  import CodeRomeDto from "../../../dtos/CodeRomeDto";
  import PostePrevisionnelDto from "../../../dtos/PostePrevisionnelDto";
  import formatTrimestre from "../../../filters/formatTrimestre";
  import TrimestreStore from "../../../stores/TrimestreStore";
  import MultiselectCustom from "../../../components/MultiselectCustom";
  import {gpecPrevisionnel, libelles} from '../../../constants/libelles';
  import DispenseReportingDto from "../../../dtos/DispenseReportingDto";
  import ReportingStore from "../../../stores/ReportingStore";
  import AutocompleteCustom from "../../../components/AutocompleteCustom";
  import {EventBus} from '@/event-bus'

  export default {
    components: {
      LabelCustom,
      FormationGpec,
      TypeContratGpec,
      CreerCodeRome,
      MultiselectCustom,
      AutocompleteCustom
    },
    data() {
      return {
        formSubmitted: false,
        show: true,
        sessionStoreState: SessionStore.state,
        filterLibellePoste: null,
        filterStatutPoste: null,
        synthese: new GpecSynthesePrevisionnelDto(),
        newCodeRome: null,
        currentTrimestre: 0,
        marcheAdmin: null,
        marchesAdmin: [],
        marches: [],
        trimestreAdmin: null,
        trimestresAdmin: [],
        typologiePosteEnum: TypologiePosteEnum,
        typologies: Object.entries(TypologiePosteEnum).map((value) => {
          return {text: value[1], value: value[0]};
        }),
        typesContratEnum: Object.entries(TypeContratEnum).map((value) => {
          return {text: value[1], value: value[0]};
        }),
        typesFormation: [],
        libelles: libelles,
        gpecPrevisionnel: gpecPrevisionnel,
        marcheIdsItems: [],
      };
    },
    computed: {
      user() {
        if(this.mode === "BROUILLON" || this.mode === "CREATE"){
          return {
          email: SessionStore.state.email, 
          prenom: SessionStore.state.prenom, 
          nom: SessionStore.state.nom}
        }
          return{
          email: this.synthese.user?.email || '',
          prenom: this.synthese.user?.prenom || '',
          nom: this.synthese.user?.nom || ''
        }
    },
      mode() {
        return !this.$route.params.id || this.synthese.statut === "BROUILLON" ? "CREATE" : (this.synthese.statut === "VALIDE" && !hasPermission(["CORRESPONDANT_GPEC_LECTURE"])) ? "UPDATE" : "READ";
      },
      isAdminGpec() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_GPEC_ADMINISTRATEUR"]);
      },
      isAdmin() {
        return this.isAdminGpec && !this.sessionStoreState.marches.length;
      },
      marche() {
        return this.isAdmin ? this.marches.find((marche) => marche.id === this.marcheAdmin) : this.sessionStoreState.marche;
      },
      marcheId() {
        return this.mode === "CREATE" ? this.isAdmin ? this.marcheAdmin : this.sessionStoreState.marche.id : this.synthese.marche ? this.synthese.marche.id : null;
      },
      currentPostes() {
        let postes = this.synthese.postesByTrimestre[this.currentTrimestre];
        if (this.filterLibellePoste) {
          postes = postes.filter((poste) => poste.codeRome.libelle.toLowerCase().includes(this.filterLibellePoste.toLowerCase()));
        }
        if (this.filterStatutPoste) {
          postes = postes.filter((poste) => poste.isTouched || this.isValid(poste));
        }
        if (postes && postes.length > 0) {
          postes = postes.map((p) => {
            p.ouvertureInsertion = p.nbRecrutement ? p.ouvertureInsertion : undefined;
            return p;
          });
        }
        return postes;
      },
      trimestres() {
        let trimestres = this.synthese.trimestresSuivants.map((value, index) => {
          return {value, index};
        });
        trimestres = trimestres.filter(
            (trimestre) => trimestre.index > this.currentTrimestre
        );
        if (trimestres && trimestres.length > 0) {
          trimestres = trimestres.map((trimestre) => {
            return {text: trimestre.value.libelle, value: trimestre.index};
          });
        }
        return trimestres;
      },
    },
    watch: {
      $route() {
        this.initSynthese();
      },
      marcheAdmin(newMarcheAdmin) {
        this.onMarcheSearch(newMarcheAdmin, true);
        this.callInit()
      },
    },
    mounted() {
      TypeFormationStore.getAll().then((response) => {
        this.typesFormation = response.map((value) => {
          return {text: value.libelle, value: value};
        });
      });
      TrimestreStore.getAll().then(trimestres => {
        this.trimestresAdmin = trimestres.map(trimestre => {
          return {text: `${trimestre.libelle}`, value: trimestre.id};
        });
      });
      if (this.isAdmin) {
        MarcheStore.getAll().then((marches) => {
          this.marches = marches;
          this.marchesAdmin = marches.map((marche) => {
            return {
              text: `${marche.reference} (${marche.libelleCourt})`,
              value: marche.id,
            };
          });
          this.marcheIdsItems = this.marchesAdmin;
        });
      }
      EventBus.$on("NavBar-marcheChange", () => {
        if (!this.isAdmin) {
          this.initSynthese();
        }
      });
      if (!this.$route.params.id) {
        TrimestreStore.getCurrentTrimestre(false).then((trimestre) => {
          this.trimestreAdmin = trimestre.id;
          this.callInit();
        });
      } else {
        this.initSynthese();
      }
    },
    beforeDestroy() {
      EventBus.$off("NavBar-marcheChange");
    },
    methods: {
      initSynthese() {
        this.marcheAdmin = null;
        this.trimestreAdmin = null;
        this.formSubmitted = false;
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
        });
        if (this.$route.params.id) {
          GpecSynthesePrevisionnelStore.get(this.$route.params.id).then(
              (value) => {
                if (value) {
                  this.synthese = value;
                  this.marcheAdmin = value.marche.id;
                  this.trimestreAdmin = value.trimestre.id;
                }
              }
          );
        } else {
          this.callInit();
        }
      },
      callInit() {
        if (this.marcheId && this.trimestreAdmin && this.mode === 'CREATE' && !this.$route.params.id) {
          GpecSynthesePrevisionnelStore.getCurrentDraft(this.marcheId, this.trimestreAdmin).then((value) => {
            if (value) {
              AlertStore.pushSuccess("Votre formulaire est actuellement enregistré en brouillon, n'oubliez pas de compléter votre saisie avant de soumettre le formulaire pour le valider");
              this.synthese = value;
              this.trimestreAdmin = value.trimestre.id;
            } else {
              GpecSynthesePrevisionnelStore.init(this.marcheId, this.trimestreAdmin).then((synthese) => {
                if (synthese) {
                  this.synthese = synthese;
                  this.trimestreAdmin = synthese.trimestre.id;
                }
              });
            }
          });
        }
      },
      formatTrimestre(trimestreLibelle) {
        return formatTrimestre(trimestreLibelle);
      },
      getFieldState(fieldState, poste) {
        const posteTouched = poste ? poste.isTouched : true;
        return this.formSubmitted && posteTouched ? fieldState : null;
      },
      getCommentaireState() {
        const commentaireValid = this.mode === 'CREATE' ? true : this.synthese.jourSoumissionPassed ? this.synthese.commentaire != null : true;
        return this.formSubmitted ? commentaireValid : null;
      },
      getStatus(poste) {
        if (this.isValid(poste)) {
          return "success";
        } else {
          return !poste.isTouched ? "secondary" : "danger";
        }
      },
      isFilledInput(value) {
        return value != null && value !== "";
      },
      areTypesContratValid(poste) {
        const typesContrat = poste.typesContrat;
        if (typesContrat == null || typesContrat.length === 0 || !this.isFilledInput(poste.nbRecrutement)) {
          return true;
        } else {
          const sommeTypesContrat = typesContrat.reduce((acc, currentVal) => {
            return this.isFilledInput(currentVal.nbEffectif)
                ? acc + Number(currentVal.nbEffectif)
                : acc;
          }, 0);
          return sommeTypesContrat === Number(poste.nbRecrutement);
        }
      },
      areTypesFormationValid(poste) {
        const formation = poste.formation;
        if (formation == null || !this.isFilledInput(poste.nbRecrutement)) {
          return true;
        } else {
          const nbInsertion = poste.ouvertureInsertion ? formation.nbInsertion : 0;
          const sommeEffectifs =
              (this.isFilledInput(nbInsertion) ? Number(nbInsertion) : 0) +
              (this.isFilledInput(formation.nbInsertionHorsInsertion)
                  ? Number(formation.nbInsertionHorsInsertion)
                  : 0);
          return sommeEffectifs <= Number(poste.nbRecrutement);
        }
      },
      isValid(poste) {
        const fieldsOk = poste.codeRome.type != null && this.isFilledInput(poste.nbRecrutement) && this.isFilledInput(poste.ouvertureInsertion);
        const formation = poste.formation;
        const formationOk = formation == null || (formation != null && formation.type != null && this.isFilledInput(formation.duree) &&
            this.isFilledInput(formation.nbInsertionHorsInsertion) && (poste.ouvertureInsertion ? this.isFilledInput(formation.nbInsertion) : true) &&
            this.areTypesFormationValid(poste));
        const typesContrat = poste.typesContrat;
        const everyTypeContratOk = typesContrat != null &&
            typesContrat.every((typeContrat) => typeContrat.type != null && this.isFilledInput(typeContrat.nbEffectif));
        const typesContratOk = everyTypeContratOk && typesContrat.length > 0 && this.areTypesContratValid(poste);
        return fieldsOk && formationOk && typesContratOk;
      },
      onOuvertureInsertionChange(poste) {
        if (poste.formation) {
          poste.formation.nbInsertion = null;
          poste.formation.nbInsertionHorsInsertion = null;
        }
      },
      showModalAddPoste() {
        this.newCodeRome = new CodeRomeDto();
        this.$bvModal.show("modal-add-poste");
      },
      addPoste() {
        if (this.newCodeRome.id != null) {
          if (this.synthese.postesByTrimestre[this.currentTrimestre].find((poste) => poste.codeRome.id === this.newCodeRome.id)) {
            AlertStore.pushError("le poste que vous souhaitez ajouter existe déjà dans le référentiel. En remontant en haut du formulaire vous pouvez filtrer la liste sur ce poste en entrant son intitulé dans la barre de recherche");
          } else {
            const poste = new PostePrevisionnelDto();
            poste.isTouched = true;
            if (!this.newCodeRome.type) {
              this.newCodeRome.customType = true;
            }
            poste.codeRome = this.newCodeRome;
            poste.trimestre = this.synthese.trimestresSuivants[this.currentTrimestre];
            poste.trimestresToDuplicate = [];
            this.synthese.postesByTrimestre[this.currentTrimestre].push(poste);
            const correspondantGpecMsg = "Le poste a bien été ajouté au référentiel, en attente de validation de son intitulé et ajout définitif au référentiel, vous pouvez saisir les besoins qui y sont associés";
            const adminMsg = "Le poste a bien été ajouté au référentiel, vous pouvez saisir les besoins qui y sont associés";
            const successMessage = this.isAdminGpec ? adminMsg : correspondantGpecMsg;
            AlertStore.pushSuccess(successMessage);
          }
          this.filterLibellePoste = null;
          this.filterStatutPoste = null;
        }
      },
      deletePoste(posteIndex) {
        this.synthese.postesByTrimestre[this.currentTrimestre].splice(posteIndex, 1);
      },
      saveDraft(isDuplicated) {
        this.filterValidPoste(this.synthese);
        this.synthese.marche = this.marche;
        GpecSynthesePrevisionnelStore.saveDraft(this.synthese).then((value) => {
          this.synthese = value;
          let msg = isDuplicated ? "Votre saisie a bien été dupliquée et est enregistrée en mode brouillon"
              : "Besoins prévisionnels en recrutements enregistrés avec succès";
          AlertStore.pushSuccess(msg);
        });
      },
      onSubmit(evt) {
        evt.preventDefault();
        this.filterStatutPoste = null;
        this.filterLibellePoste = null;
        const marcheAdminOk = this.isAdmin ? this.marcheAdmin != null : true;
        const auMoinsUnPosteValide = this.synthese.postesByTrimestre.some((postes) => postes.some((poste) => this.isValid(poste)));
        if (!auMoinsUnPosteValide) {
          AlertStore.pushError(`La saisie doit comprendre au moins un besoin exprimé sur l'un des trimestres pour pouvoir soumettre le formulaire.`);
          return;
        }
        if (marcheAdminOk && this.getCommentaireState()
            && this.synthese.postesByTrimestre.every((postes) => postes.every((poste) => this.isValid(poste) || !poste.isTouched))) {
          this.filterValidPoste(this.synthese);
          if (this.mode === "CREATE") {
            this.synthese.marche = this.isAdmin ? this.marches.find((marche) => marche.id === this.marcheAdmin)
                : this.sessionStoreState.marche;
            GpecSynthesePrevisionnelStore.create(this.synthese).then(() => this.initSynthese());
          } else {
            GpecSynthesePrevisionnelStore.update(this.synthese).then(() =>
                this.$router.push("/gpec-besoins-previsionnels/consultation")
            );
          }
        } else {
          AlertStore.pushError(`Votre formulaire est incomplet. Veuillez finaliser votre saisie pour valider le formulaire.`);
        }
      },
      validerSynthese(synthese) {
        GpecSynthesePrevisionnelStore.validate(synthese).then(() => {
          this.$router.push("/gpec-besoins-previsionnels/validation");
        });
      },
      duplicatePoste(poste, posteIndex) {
        if (poste.trimestresToDuplicate.every((index) => {
          return this.synthese.postesByTrimestre[index][posteIndex] ? this.isValid(this.synthese.postesByTrimestre[index][posteIndex])
              ? this.synthese.postesByTrimestre[index][posteIndex].codeRome.id !== poste.codeRome.id : true : true;
        })
        ) {
          this.clonePoste(poste);
        } else {
          this.showConfirmationDuplicatePoste(poste, posteIndex);
        }
      },
      clonePoste(poste) {
        if (poste.trimestresToDuplicate && poste.trimestresToDuplicate.length > 0) {
          poste.trimestresToDuplicate.forEach((index) => {
            let posteIndex = this.synthese.postesByTrimestre[index].findIndex(
                (p) => p.codeRome.id === poste.codeRome.id
            );
            let posteIndexToclone = posteIndex >= 0 ? posteIndex : this.synthese.postesByTrimestre[index].length + 1;
            //copier juste les valeurs pas les références d'objet
            this.synthese.postesByTrimestre[index][posteIndexToclone] = JSON.parse(JSON.stringify(poste));
            // mettre les id à null pour une nouvelle insertion
            this.synthese.postesByTrimestre[index][posteIndexToclone].id = null;
            this.synthese.postesByTrimestre[index][posteIndexToclone].typesContrat.forEach((contrat) => {
              contrat.id = null;
            });
            if (this.synthese.postesByTrimestre[index][posteIndexToclone].formation) {
              this.synthese.postesByTrimestre[index][posteIndexToclone].formation.id = null;
            }
            this.synthese.postesByTrimestre[index][posteIndexToclone].trimestre = this.synthese.trimestresSuivants[index];
          });
          if (this.mode === "CREATE") {
            this.saveDraft(true);
          } else {
            this.updateDuplicateposte();
          }
        }
      },
      showConfirmationDuplicatePoste(poste) {
        const h = this.$createElement;
        const message = h("div", [
          h("p", [" Le poste à dupliquer existe déjà sur au moins un trimestre sélectionné.",
            h("p", ""),
            h("p", "Confirmez-vous sa duplication ?"),
            h("p", "Si vous validez, cette duplication viendra alors remplacer la duplication saisie antérieurement sur ce poste"
            ),
          ]),
        ]);
        this.$bvModal
            .msgBoxConfirm([message], {
              title: "Confirmation de la duplication du poste",
              okTitle: "Valider",
              cancelTitle: "Annuler",
            })
            .then((value) => {
              if (value) {
                this.clonePoste(poste);
              }
            });
      },
      updateDuplicateposte() {
        let saveSynthese = JSON.parse(JSON.stringify(this.synthese));
        this.filterValidPoste(saveSynthese);
        GpecSynthesePrevisionnelStore.update(saveSynthese, true);
      },
      filterValidPoste(saveSynthese) {
        for (let i = 0; i < saveSynthese.postesByTrimestre.length; i++) {
          saveSynthese.postesByTrimestre[i] = saveSynthese.postesByTrimestre[i].filter((poste) => this.isValid(poste));
        }
      },
      initTrimestresToDuplicate(poste) {
        poste.trimestresToDuplicate = [];
      },
      addLineBreak(event, object, code, lineBreack) {
        object[code] = lineBreack ? event.target.value + '\n' : event
      },
      saveDispense() {
        const dispense = new DispenseReportingDto();
        dispense.marche = this.marche;
        dispense.ongletReporting = "GPEC_PREVISIONNEL";
        dispense.trimestreId = this.trimestreAdmin;
        ReportingStore.create(dispense, true);
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
      }
    },
  };
</script>

<style lang="scss" scoped>
    .card-body {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
    .user-info {
        background-color: #f0f0f0;
        padding: 10px;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        box-sizing: border-box;
        word-break: break-word;
    }
    .no-data {
        text-align: center;
        font-style: italic;
        color: #888;
    }
</style>
